import { supabase } from '../../core/config/supabase';
import { TournamentAdminEntity } from '../entities';

export class TournamentAdminDataSource {
  async create(admin: Omit<TournamentAdminEntity, 'id' | 'created_at'>): Promise<TournamentAdminEntity> {
    const { data, error } = await supabase
      .from('tournament_admins')
      .insert(admin)
      .select()
      .single();

    if (error) throw new Error(error.message);
    if (!data) throw new Error('No data returned from insert');

    return data as TournamentAdminEntity;
  }

  async getByTournamentId(tournamentId: string): Promise<TournamentAdminEntity[]> {
    const { data, error } = await supabase
      .from('tournament_admins')
      .select('*')
      .eq('tournament_id', tournamentId);

    if (error) throw new Error(error.message);

    return (data as TournamentAdminEntity[]) || [];
  }

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('tournament_admins')
      .delete()
      .eq('id', id);

    if (error) throw new Error(error.message);
  }

  async deleteByUserAndTournament(userId: string, tournamentId: string): Promise<void> {
    const { error } = await supabase
      .from('tournament_admins')
      .delete()
      .eq('user_id', userId)
      .eq('tournament_id', tournamentId);

    if (error) throw new Error(error.message);
  }
}